export default __webpack_public_path__ + "static/media/459.82ca96fe.png";